/**
 * Время события с учётом офлайна.
 *
 * Действие, совершённое без сети, доезжает до сервера позже — иногда
 * на часы. Показывать серверное время значило бы утверждать, что
 * водитель заполнил приёмку в момент появления сети, а это неправда.
 *
 * Поэтому показываем клиентское время, но с явной пометкой: оно
 * пришло с устройства и не является доказательством. Решения
 * о нарушениях принимаются по серверному времени.
 */
import { formatDateTime } from './format'

/** Порог, с которого расхождение стоит показывать. */
export const DIVERGENCE_THRESHOLD_SECONDS = 15 * 60

/**
 * @param {{ occurred_at?: string, created_at?: string,
 *           time_divergence_seconds?: number }} entry
 */
export function describeTime(entry) {
  if (!entry) return null

  const server = entry.created_at
  const client = entry.occurred_at
  const divergence = entry.time_divergence_seconds

  // Обычный случай: действие записано сразу.
  if (!client || !divergence) {
    return {
      label: formatDateTime(server),
      isOffline: false,
      title: null,
    }
  }

  return {
    // Показываем, когда водитель это сделал…
    label: formatDateTime(client),
    isOffline: true,
    // …и объясняем, откуда взялось время.
    title:
      `Действие выполнено без сети и получено сервером ` +
      `${formatDateTime(server)} (через ${humanizeDuration(divergence)}). ` +
      `Время с устройства — справочное.`,
    delay: humanizeDuration(divergence),
  }
}

export function humanizeDuration(seconds) {
  if (!seconds || seconds < 60) return 'меньше минуты'
  const d = Math.floor(seconds / 86400)
  const h = Math.floor((seconds % 86400) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  if (d) return `${d} дн. ${h} ч.`
  if (h) return `${h} ч. ${m} мин.`
  return `${m} мин.`
}
